export const MOBILE_COUNTRY_OPTIONS = [
  { code: "IE", calling: "353", label: "Ireland (+353)" },
  // { code: "GB", calling: "44", label: "United Kingdom (+44)" },
  { code: "DE", calling: "49", label: "Germany (+49)" },
  { code: "PL", calling: "48", label: "Poland (+48)" },
  { code: "IN", calling: "91", label: "India (+91)" },
  // { code: "US", calling: "1", label: "United States (+1)" },
];

export const getCallingCodeForCountry = (code) =>
  MOBILE_COUNTRY_OPTIONS.find((c) => c.code === code)?.calling || "";
